/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
    DayOfWeekToJSONTyped,
} from './DayOfWeek';

/**
 * 
 * @export
 * @interface ClassDayResponse
 */
export interface ClassDayResponse {
    /**
     * 
     * @type {DayOfWeek}
     * @memberof ClassDayResponse
     */
    day: DayOfWeek;
    /**
     * 
     * @type {string}
     * @memberof ClassDayResponse
     */
    startTime: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassDayResponse
     */
    endTime: string | null;
}



/**
 * Check if a given object implements the ClassDayResponse interface.
 */
export function instanceOfClassDayResponse(value: object): value is ClassDayResponse {
    if (!('day' in value) || value['day'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function ClassDayResponseFromJSON(json: any): ClassDayResponse {
    return ClassDayResponseFromJSONTyped(json, false);
}

export function ClassDayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassDayResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'day': DayOfWeekFromJSON(json['day']),
        'startTime': json['startTime'],
        'endTime': json['endTime'],
    };
}

export function ClassDayResponseToJSON(json: any): ClassDayResponse {
    return ClassDayResponseToJSONTyped(json, false);
}

export function ClassDayResponseToJSONTyped(value?: ClassDayResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'day': DayOfWeekToJSON(value['day']),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
    };
}

